<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="33.766" height="30.741" viewBox="0 0 33.766 30.741">
    <g id="Gruppe_60" data-name="Gruppe 60" transform="translate(0.25 0.25)">
      <path id="Pfad_30" data-name="Pfad 30" d="M32.413,23.877H12.756a.756.756,0,1,1,0-1.512H31.808L34.53,9.512H16.877a.756.756,0,0,1,0-1.512h18.56a.688.688,0,0,1,.6.3.815.815,0,0,1,.151.6L33.169,23.272A.736.736,0,0,1,32.413,23.877Z" transform="translate(-2.928 -1.952)" fill="#383737" stroke="#383737" stroke-width="0.5"/>
      <path id="Pfad_31" data-name="Pfad 31" d="M16.316,9.512H8.756A.756.756,0,1,1,8.756,8h7.56a.756.756,0,0,1,0,1.512Z" transform="translate(-1.952 -1.952)" fill="#383737" stroke="#383737" stroke-width="0.5"/>
      <path id="Pfad_32" data-name="Pfad 32" d="M27.217,24.193H11.189L6.048.6A.736.736,0,0,0,5.292,0H.756A.714.714,0,0,0,0,.756a.714.714,0,0,0,.756.756H4.687L9.753,24.647a3.121,3.121,0,0,0-1.436,2.571,3.024,3.024,0,1,0,6.048,0,2.726,2.726,0,0,0-.454-1.512h10.66a3.521,3.521,0,0,0-.454,1.512,3.024,3.024,0,1,0,6.048,0A2.969,2.969,0,0,0,27.217,24.193ZM12.853,27.217a1.512,1.512,0,1,1-1.512-1.512A1.517,1.517,0,0,1,12.853,27.217Zm14.365,1.512a1.512,1.512,0,1,1,1.512-1.512A1.517,1.517,0,0,1,27.217,28.729Z" fill="#383737" stroke="#383737" stroke-width="0.5"/>
    </g>
  </svg>
</template>

<script>
export default {
name: "cartIcon"
}
</script>

<style scoped>

</style>